module.exports = __webpack_public_path__ + "img/mobile.f03922cf.svg";